import React, { useState } from "react";
import "../../styles/page/home.css";
import { Link } from "react-router-dom";
import Img from "../../components/ui/Img";
import jem_logo from "../../assets/images/jem-logo.png";
import jemLastEvent2019Kids from "../../assets/images/jem-2019-event-kids.jpg";
import jemFeedingKids from "../../assets/images/evg-tina-feeding-kids.jpg";
import imago_dei from "../../assets/images/imago-dei.png";
import times_intelligentsia from "../../assets/images/times-intelligentsia.png";
import soreal from "../../assets/images/soreal.png";
import jemOutreachHomeless from "../../assets/images/jem-outreach-homeless-2nd.jpeg";
import OutlineLink from "../../components/ui/OutlineLink";
import LinkButton from "../../components/ui/LinkButton";
import { ReactComponent as WhatsappIcon } from "../../assets/svg/whatsapp-green.svg";
import { ReactComponent as TargetIcon } from "../../assets/svg/target.svg";
import { ReactComponent as ChurchIcon } from "../../assets/svg/church.svg";
import { ReactComponent as BibleIcon } from "../../assets/svg/bible.svg";
import { ReactComponent as PrayHandIcon } from "../../assets/svg/pray-hand.svg";
import { ReactComponent as FingerPointLeftIcon } from "../../assets/svg/finger-point-right.svg";
import OutlineButton from "../../components/ui/OutlineButton";
import { RegularServiceTable } from "./RegularServiceTable";
import EmailSubscriptionBox from "./EmailSubscriptionBox";

const HomePage = () => {
  const { handleZoomIn } = useHome();
  return (
    <>
      {/* //??__________________HERO SECTION__________________??// */}
      <main className="bg-praying-woman-hero p-6 min-h-[500px] bg-center bg-cover">
        <div className="wrapper flex gap-10 items-center min-h-[400px] flex-col-reverse md:flex-row relative top-10">
          <div className="w-full md:block flex justify-end flex-col items-end">
            <div className="ml-8 md:max-w-[15rem] bg-opacity-30 backdrop-blur-md bg-white shadow-lg p-6 rounded-lg w-full md:block flex items-center gap-3">
              <Img
                src={jem_logo}
                alt="Jesus Empowerment Ministries Logo"
                width="60"
              />
              <p className="font-bold leading-6 text-lg mt-5 text-white drop-shadow-lg">
                Jesus <br />
                Empowerment <br />
                Ministries
              </p>
            </div>
          </div>
          <div className="w-full">
            <p className="font-bold text-transparent md:text-3xl text-4xl bg-clip-text bg-gradient-to-r from-white to-sky-blue drop-shadow-[0_2px_1px_rgba(20,20,20)] mb-4">
              EXPERIENCE CHRIST. EXPERIENCE GRACE...
            </p>
            <LinkButton
              to="tel:+2348140302909"
              href="tel:+2348140302909"
              className="px-6 md:hidden block"
            >
              CONTACT US
            </LinkButton>
            <OutlineLink
              className="px-6 hidden md:inline-block"
              href="tel:+2348140302909"
              to="tel:+2348140302909"
            >
              CONTACT US
            </OutlineLink>
          </div>
        </div>
      </main>
      {/* //??___________________OUR MISSION AREA_________________??// */}
      <section className="bg-white bg-net-scale p-7">
        <div className="wrapper text-pale-blue text-center">
          <span className="text-2xl font-bold flex justify-center items-center gap-4">
            <h3>Our Mission At J.E.M</h3>
            <TargetIcon width={40} height={40} className="-mt-2" />
          </span>
          <p className="py-4 text-lg font-medium max-w-xl m-auto">
            Our mission is to find the lost warriors who were born to partake in
            this holy way but has forgotten their heaven given identity as
            mentioned in the book of Jeremiah (know you before you were born)
            but are now wandering in the darkness to find their true-self. There
            are desperate souls seeking out the face of our true God.
          </p>
          <Link to="/">Learn More...</Link>
        </div>
      </section>
      {/* //??_____________________CARDS SECTION___________________??// */}
      <div className="bg-sky-blue p-6">
        <div className="wrapper !max-w-6xl flex justify-between items-center gap-4 flex-col md:flex-row">
          <div className="bg-white p-4 flex flex-col items-center text-center gap-4 max-w-xs rounded-xl shadow-md">
            <span>
              <ChurchIcon width={35} height={35} className="" />
            </span>
            <p>
              importance of the Bible and the centrality of Jesus Christ in
              their religious beliefs.
            </p>
          </div>
          <div className="bg-white p-4 flex flex-col items-center text-center gap-4 max-w-xs rounded-xl shadow-md">
            <span>
              <BibleIcon width={35} height={35} className="" />
            </span>
            <p>
              importance of the Bible and the centrality of Jesus Christ in
              their religious beliefs.
            </p>
          </div>
          <div className="bg-white p-4 flex flex-col items-center text-center gap-4 max-w-xs rounded-xl shadow-md">
            <span>
              <PrayHandIcon width={40} height={40} className="" />
            </span>
            <p>
              importance of the Bible and the centrality of Jesus Christ in
              their religious beliefs.
            </p>
          </div>
        </div>
      </div>
      {/* //??_____________________IMAGES PREVIEW SHOW SECTION___________________??// */}
      <div className="bg-white md:p-10 p-4 pt-10 pb-8">
        <div className="wrapper">
          <div className="max-w-xl">
            <p className="text-sky-blue text-2xl font-extrabold mb-4">
              Jesus Empowerment Ministries empowers the world with hope, love,
              and Christ's teachings
            </p>
            <p className="">
              We will sound the trumpet of empathy and compassion across our
              street and town to bring the message that christ is present in
              each and everyone despite enemy trying keep us away from this
              truth
            </p>
          </div>
          <div className="overflow-hidden grid grid-cols-2 gap-4 max-w-4xl max-h-96 mt-8 md:ml-8 md:min-h-[450px]">
            <div className="rounded row-span-2 justify-self-end self-center h-full md:min-h-[500px] w-full">
              <Img
                src={jemFeedingKids}
                onClick={handleZoomIn}
                className="h-full w-full hover:scale-105"
                alt="JEM Feeding idioro Kids"
              />
            </div>
            <div className="">
              <div className="">
                <Img
                  src={jemLastEvent2019Kids}
                  onClick={handleZoomIn}
                  className="rounded w-full md:w-3/4 h-3/6 hover:scale-105"
                  alt="JEM Last Event 2019 Kids"
                />
              </div>
              <div className="">
                <Img
                  src={jemOutreachHomeless}
                  onClick={handleZoomIn}
                  className="rounded  w-full md:w-3/4 mt-3 hover:scale-105"
                  alt="JEM Outreach to The Homeless"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* //??_____________________DONATE SCREEN SECTION___________________??// */}
      <div className="md:flex bg-white">
        <div className="bg-wave-whirl min-h-[300px] w-full py-4 bg-center bg-cover flex flex-col items-center justify-center">
          <span className="flex items-center gap-4 text-white p-4">
            <p className="font-semibold text-lg text-white">
              Be part of God's journey to help others in need{" "}
            </p>
            <FingerPointLeftIcon
              width={35}
              height={35}
              className="-mt-2 hidden md:inline-block"
            />
          </span>
        </div>
        <div className="bg-evg-tina-helping min-h-[300px] md:w-10/12 bg-blue-600 bg-center bg-cover flex flex-col items-center justify-center relative">
          <div className="border-4 rounded-full h-1/2 aspect-square absolute animate-ping"></div>
          <OutlineButton className="px-8 scale-125 tracking-widest leading-5">
            DONATE
          </OutlineButton>
        </div>
      </div>
      {/* //??_____________________SERVICES DATES TABLE___________________??// */}
      <RegularServiceTable />
      {/* //??_____________________DAILY BIBLE VERSE___________________??// */}
      <div className="relative bg-wavy-bottom bg-cover min-h-[220px] pt-4">
        <div className="flex flex-col items-center justify-center pb-6">
          <h4 className="text-sky-blue text-2xl font-bold mt-4 mb-2">
            Daily Bible Verse
          </h4>
          <div className="bg-white border-2 border-sky-blue max-w-sm p-4 rounded shadow-md">
            <p className="first-letter:font-semibold first-letter:text-lg mb-2">
              For GOD so love the world that he gave his only begotten son
            </p>
            <small>
              <cite>John 3:16-17</cite>
            </small>
          </div>
        </div>
      </div>
      {/* //??_____________________SPONSORS___________________??// */}
      <div className="px-4">
        <div className="wrapper py-6">
          <h4 className="text-center mb-4 font-semibold text-lg">
            Our Sponsors
          </h4>
          <div className="flex items-center justify-between gap-4 m-auto max-w-2xl">
            <Img
              src={imago_dei}
              className="mix-blend-luminosity hover:mix-blend-normal"
              width="70"
              alt="Imago Dei Ministries"
            />

            <Img
              src={soreal}
              className="mix-blend-luminosity hover:mix-blend-normal"
              width="130"
              alt="Soreal By Toniez"
            />

            <Img
              src={times_intelligentsia}
              className="mix-blend-luminosity hover:mix-blend-normal"
              width="90"
              alt="Times & Intelligentsia"
            />
          </div>
        </div>
      </div>
      {/* //??_____________________NEWSLETTER WHATSAPP COMMUNITY___________________??// */}
      <div className="md:flex">
        <div className="lg:pl-20 bg-kids-raising-hands bg-cover w-full p-6 min-h-[200px] flex flex-col justify-center gap-10">
          <p className="text-white max-w-xl">
            Join our Whatsapp community team to keep up with most of our
            upcoming programs, events and more.
          </p>

          <span className="flex items-center">
            <WhatsappIcon width={35} height={35} className="mr-2" />
            <a
              href="https://chat.whatsapp.com/L4hdGWr9ZzOHUYeXskdB1H"
              target="_blank"
              rel="noopener noreferrer"
              className="text-green-500 text-lg font-semibold underline"
            >
              Click now to join!
            </a>
          </span>
        </div>
        {/* //??__________NEWSLETTER INPUTS BOX_______??// */}
        <EmailSubscriptionBox />
      </div>
    </>
  );
};

export default HomePage;

const useHome = () => {
  const [zoomIn] = useState("zoomIn");

  const handleZoomIn = (e: React.MouseEvent<HTMLImageElement>) => {
    if (e.currentTarget.className.includes("zoomIn")) {
      e.currentTarget.className = e.currentTarget.className
        .replace("zoomIn", "")
        .trim();
    } else {
      e.currentTarget.className = e.currentTarget.className + " " + zoomIn;
    }
    console.log(e.target);
  };

  return { handleZoomIn, zoomIn };
};
